import React from 'react'
import AppNavbar from '../components/Navbar/Navbar'
import Courses from '../components/Courses/Courses'
import Footer from '../components/Footer/Footer'

const CoursesPage = () => {
  return (
    <div>
        <AppNavbar/>
         <Courses/>
         <Footer/>
    </div>
  )
}

export default CoursesPage